/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  DeleteProductsMutationRequest,
  DeleteProductsMutationResponse,
} from "../types/DeleteProducts.ts"

export const deleteProductsMutationKey = () =>
  [{ url: "/v1/product/mass-delete-products" }] as const

export type DeleteProductsMutationKey = ReturnType<
  typeof deleteProductsMutationKey
>

/**
 * @summary Delete multiple products
 * {@link /v1/product/mass-delete-products}
 */
export async function deleteProducts(
  data?: DeleteProductsMutationRequest,
  config: Partial<RequestConfig<DeleteProductsMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    DeleteProductsMutationResponse,
    ResponseErrorConfig<Error>,
    DeleteProductsMutationRequest
  >({
    method: "DELETE",
    url: `/v1/product/mass-delete-products`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function deleteProductsMutationOptions(
  config: Partial<RequestConfig<DeleteProductsMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = deleteProductsMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data?: DeleteProductsMutationRequest },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return deleteProducts(data, config)
    },
  })
}

/**
 * @summary Delete multiple products
 * {@link /v1/product/mass-delete-products}
 */
export function useDeleteProducts<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteProductsMutationResponse>,
      ResponseErrorConfig<Error>,
      { data?: DeleteProductsMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<DeleteProductsMutationRequest>> & {
      client?: typeof fetch
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? deleteProductsMutationKey()

  const baseOptions = deleteProductsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DeleteProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data?: DeleteProductsMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data?: DeleteProductsMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data?: DeleteProductsMutationRequest },
    TContext
  >
}
